'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardWizardCtrl', ['$uibModal', '$state', '$window','$scope',
    '$http', '$sce', 'dialog', 'toast', 'Container', 'Authentication', require('./dashboardWizardCtrl')]);

app.config(['$stateProvider', '$urlRouterProvider', require('./dashboardWizardConfig')]);
